import { useParams } from 'react-router-dom';

import styled from 'styled-components';

import MissionProgressGraph from 'components/dashboard/cardinal/progress/MissionProgressGraph';
import { useGetCreatorGroupSummary } from 'hooks/queries/creator';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import CoreTag from 'shared/tag/CoreTag';
import { ReportSectionCard, ReportSectionText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

export const groupMockData = {
	groupMonth: '2024-06', // 현재 월 예시
	contentStatus: {
		reels: {
			scheduledContent: 12,
			uploadedContent: 8,
		},
		styleClips: {
			scheduledContent: 15,
			uploadedContent: 10,
		},
	},
	missionStatus: [
		{
			missionNumber: 1,
			progress: '완료',
			productPurchase: {
				completed: 1,
			},
			contentShooting: {
				completed: 1,
			},
			reelsUpload: {
				completed: 0,
				notStarted: 5,
			},
			styleClipUpload: {
				completed: 1,
				notStarted: 3,
			},
			contentEngagement: 107,
			rank: 2,
		},
		{
			missionNumber: 2,
			progress: '진행',
			productPurchase: {
				completed: 0,
			},
			contentShooting: {
				completed: 1,
			},
			reelsUpload: {
				completed: 0,
				notStarted: 6,
			},
			styleClipUpload: {
				completed: 1,
				notStarted: 7,
			},
			contentEngagement: 1011,
			rank: 3,
		},
		{
			missionNumber: 3,
			progress: '예정',
			productPurchase: {
				completed: 0,
			},
			contentShooting: {
				completed: 0,
			},
			reelsUpload: {
				completed: 0,
				notStarted: 10,
			},
			styleClipUpload: {
				completed: 0,
				notStarted: 12,
			},
			contentEngagement: 10290,
			rank: 1,
		},
	],
};

const ContentProgressCard = () => {
	const { groupId, creatorPk } = useParams();
	const { data: creatorGroupSummary, isLoading: creatorGroupSummaryLoading } =
		useGetCreatorGroupSummary(creatorPk, groupId);

	return (
		<Grid _gap="16px" direction="row" flex="start">
			{creatorGroupSummary?.missionStatus.map((mission, index) => (
				<ReportSectionCard
					key={index} // 각 컴포넌트의 고유 키
					_width="32%"
					_padding="16px 32px 24px 32px"
				>
					<Grid _height="100%" direction="column" flex="between" _gap="30px">
						{/* 미션 정보 */}
						<Grid flex="between" align_items="center">
							<Grid flex="start" _gap="8px">
								<Grid>{`${index + 1}차 미션`}</Grid>
							</Grid>
							<Grid _width="content">
								<CoreTag
									tag_type={'text'}
									value={mission.progress}
									color_type={
										mission.progress === '완료'
											? 'black'
											: mission.progress === '진행'
											? 'green'
											: 'gray'
									}
								/>
							</Grid>
						</Grid>

						{/* 그래프 */}
						<MissionProgressGraph
							productPurchase={{
								count: mission?.productPurchase?.completed != 0 ? 1 : 0,
								link: mission?.productPurchase?.link,
							}}
							draftSend={{
								count: mission?.draftSend?.completed != 0 ? 1 : 0,
								link: mission?.draftSend?.link,
							}}
							reelsUpload={{
								count: mission?.reelsUpload?.completed != 0 ? 1 : 0,
								link: mission?.reelsUpload?.link,
							}}
							styleClipUpload={{
								count: mission?.styleClipUpload?.completed != 0 ? 1 : 0,
								link: mission?.styleClipUpload?.link,
							}}
						/>
						<GrayLine />

						{/* 콘텐츠 인게이지먼트 */}
						<Grid flex="start" align_items="start" direction="column">
							<ReportSectionText>콘텐츠 인게이지먼트</ReportSectionText>
							<Grid flex="between">
								<ReportSectionText>{`${
									mission.contentEngagement ?? '-'
								}개`}</ReportSectionText>
								<CoreTag
									tag_type={'text'}
									value={`${mission.rank ?? '-'}위`}
									color_type={mission.rank === 1 ? 'primary' : 'gray'}
								/>
							</Grid>
						</Grid>
					</Grid>
				</ReportSectionCard>
			))}
		</Grid>
	);
};

const { Grid, Text } = style;

const GrayLine = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${({ theme }) => theme.colors.gray.gray10};
`;

export default ContentProgressCard;
